<template>
    <div>
        <div  v-if="['pedagog','hschool'].indexOf($store.state.type) === -1">
            <Status />
            <br/>
            <Responsible />
            <Equipment v-if="['media','predpri'].indexOf($store.state.type) === -1"/>
            <MediaEquipment v-if="$store.state.type=='media'"/>
            <Teachers />
            <Courses />
            <div class="line"></div>
            <div class="title-part">Мероприятия</div>
            <Events />
            <div class="line"></div>
            <Cooperation />
            <MediaCooperationPartner v-if="$store.state.type=='media'"/>
            <Graduates v-if="['media'].indexOf($store.state.type) === -1" />
            <CountPupils  />

            <div class="" v-if="$store.state.type == 'cad'">
                <Cadet />
            </div>
        </div>
        <div class="" v-else-if="$store.state.type=='pedagog'">
            <pedagog-view />
        </div>
        <div class="" v-else-if="$store.state.type=='hschool'">
            <hschool-view />
        </div>
    </div>
</template>


<script>
    import Status from './components/Status'
    import Responsible from './components/Responsible'
    import Equipment from './components/Equipment'
    import MediaEquipment from './components/MediaEquipment'
    import Teachers from './components/Teachers'
    import Courses from './components/Courses'
    import Events from './components/Events'
    import Cooperation from './components/Cooperation'
    import Graduates from './components/Graduates'
    import CountPupils from './components/count_pupils/CountPupils'
    import Cadet from './components/cadet'
    import Pedagog from './components/pedagog'
    import Hschool from './components/hschool'
    import MediaCooperationPartner from "./components/MediaCooperationPartner";
    export default {
        components: {
            Status,
            Responsible,
            Equipment,
            MediaEquipment,
            MediaCooperationPartner,
            Teachers,
            Courses,
            Events,
            Cooperation,
            Graduates,
            CountPupils,
            Cadet,
            'pedagog-view':Pedagog,
            'hschool-view':Hschool,
        },


        created(){
            this.$store.commit("setEoId", document.body.getAttribute("data-eo-id"))
            this.$store.commit("setType", document.getElementById("vue-container-profile-classes-metrics").getAttribute("data-type"))
            this.$store.dispatch("getStatus")
        }
    }
</script>


<style lang="less">
    .radius(@value){
        border-radius: @value;
        -webkit-border-radius: @value;
        -moz-border-radius: @value;
    }
    .shadow(@value: 0 0 5px 2px){
        box-shadow: @value;
        -webkit-box-shadow: @value;
        -moz-box-shadow: @value;
    }
    .block{
        margin-bottom: 10px;
        .title{
            cursor: pointer;
            background: url("assets/st_close.png") right 15px center no-repeat;
            .shadow(1px 1px 7px 0px rgba(0,0,0,0.1));
            .radius(5px);
            display: block;
            border: 1px solid #c3c3c3;
            padding: 12px 30px 10px;

            background-color: #efefef;

            color: #484b50;
            font-size: 16px;
            font-weight: 400;
            text-decoration: none;
            &:hover{
                text-decoration: none;
            }
            &.open{
                background: url("assets/st_open.png") right 15px center no-repeat #efefef;
            }
        }
        .content{
            display: block;
            padding: 5px 0px 10px;
            overflow: auto;
        }
    }
    .line{
        width: 100%;
        height: 1px;
        background-color: #d4d4d4;
        margin: 25px 0 20px;
    }
    .title-part{
        text-transform: uppercase;
        color: #6a6d72;
        font-size: 18px;
        margin: 0px 0px 15px;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
        opacity: 0;
        transition-duration: 0.1s;
    }
</style>
